import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

interface RecordAccessDeniedProps {
  backTo: '/encounters' | '/appointments';
}

/**
 * Shown when the user opens an encounter or appointment they can't access. The same
 * screen covers another provider's record, another organization's and a missing one, and it shows
 * nothing about the record itself.
 */
const RecordAccessDenied: React.FC<RecordAccessDeniedProps> = ({ backTo }) => {
  const navigate = useNavigate();
  const backLabel = backTo === '/appointments' ? 'Back to Appointments' : 'Back to Encounters';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50/30 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-6">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-red-50 flex items-center justify-center">
          <ShieldAlert className="h-8 w-8 text-red-400" />
        </div>
        <h1 className="text-xl font-medium text-slate-800 mb-2">Access Denied</h1>
        <p className="text-slate-500 mb-6">
          You don't have access to this encounter. If you think this is a mistake, contact your administrator.
        </p>
        <button
          onClick={() => navigate(backTo)}
          className="px-5 py-2.5 text-sm font-medium text-white bg-blue-500 rounded-xl hover:bg-blue-600 transition-colors"
        >
          {backLabel}
        </button>
      </div>
    </div>
  );
};

export default RecordAccessDenied;
